import React from 'react'
import Select from '../DMGComponents/Select'
import Input from '../DMGComponents/Input'
import { getAreaSettings, createArea, getAppSettingsInfo } from '../fetchData';
import Break from '../DMGComponents/Break'
import Button from '../DMGComponents/Button'
import '../assets/css/CreateArea.css'
import { isDMGUser } from '../authProvider';
import toast, { Toaster } from 'react-hot-toast';
import FileExLogo from '../components/FileExLogo';
import { withRouter } from 'react-router-dom';
import Checkbox from '../DMGComponents/Checkbox';
import { Tooltip } from 'react-tooltip';

class CreateArea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
            areaSettings: [],
            selectedAreaSetting: null,
            areaName: "",
            areaDescription: "",
            adHocCbSelected: false,
            notifyOwnerOnDownload: false,
            appSettings: { isUsaVersion: false, adHocAreasEnabled: true },
            showValidationErrors: false,
        }

        this.areaSettingSelected = this.areaSettingSelected.bind(this);
        this.areaNameChanged = this.areaNameChanged.bind(this);
        this.areaDescriptionChanged = this.areaDescriptionChanged.bind(this);
    }

    componentDidMount() {
        getAppSettingsInfo().then((res) => {
            this.setState({
                appSettings: res
            });
        }).catch(() => {
            toast.error("Error loading app settings.");
        })
        getAreaSettings().then((res) => {
            let arr = []
            res.forEach(e => {
                arr.push({ displayName: e.name, data: { id: e.id, name: e.name } })
            });
            this.setState({
                areaSettings: arr
            })
        }).catch((err) => {
            toast.error("Error loading area settings.")
            console.error("Error", err)
        })
    }

    areaSettingSelected = (selectedAreaSetting) => {
        this.setState({
            selectedAreaSetting: selectedAreaSetting
        })
    }

    areaNameChanged = (value) => {
        this.setState({
            areaName: value
        })
    }

    areaDescriptionChanged = (value) => {
        this.setState({
            areaDescription: value
        })
    }

    cancel = () => {
        this.props.history.push({ pathname: '/' })
    }

    createArea = () => {
        this.setState({ showValidationErrors: true });
        if (this.state.areaName.length > 0 && (this.state.selectedAreaSetting != null || this.state.adHocCbSelected)) {
            let areaSettingsId = this.state.selectedAreaSetting?.id ? this.state.selectedAreaSetting?.id : 0;
            createArea({ name: this.state.areaName, settingId: areaSettingsId, description: this.state.areaDescription, users: this.state.checked, isAdHocArea: this.state.adHocCbSelected, notifyOwnerOnDownload: this.state.notifyOwnerOnDownload }).then((res) => {
                if (res.isError) {
                    toast.error(res.data);
                }
                else {
                    this.props.history.push({
                        pathname: '/',
                        state: {
                            areaId: res,
                            areaCreated: true
                        }
                    })
                }
            }).catch((err) => {
                console.error("Error", err);
                toast.error("Error creating area.")
            })
        }
    }

    render() {
        const nameError = this.state.showValidationErrors && this.state.areaName.length === 0;
        const settingError = this.state.showValidationErrors && !this.state.adHocCbSelected && this.state.selectedAreaSetting == null;
        return (
            <div>
                <FileExLogo clicked={() => {
                    this.props.history.push({
                        pathname: '/'
                    })
                }} />
                {isDMGUser() &&
                    <div>
                        <Toaster />
                        <Break style={ { margin: "20px 0" }}>
                            Create Area
                        </Break>
                        <div className="ca">
                            <div className={nameError ? "ca-field-error" : ""}>
                                <Input label="Area name" value={this.state.areaName} onClick={this.areaNameChanged} />
                                {nameError && <span className="ca-error-text">Area name is required.</span>}
                            </div>
                            <Input label="Description" value={this.state.areaDescription} onClick={this.areaDescriptionChanged} />
                            <div style={{ display: "flex", alignItems: "center" }} >
                                {this.state.appSettings.adHocAreasEnabled &&
                                    <div data-tooltip-id="adhoc-tooltip" data-tooltip-content="Use Ad Hoc Area only as an alternative solution for quick data exchange instead of a USB stick.">
                                        <Checkbox style={{ marginLeft: "12px", marginRight: "24px", marginBottom: "16px", minWidth: "130px" }} checked={this.state.adHocCbSelected} onClick={(s) => { this.setState({ adHocCbSelected: s }) }}>
                                            Ad Hoc Area
                                        </Checkbox>
                                    </div>
                                }
                                <div className={settingError ? "ca-field-error" : ""} style={{ width: "100%" }}>
                                    <Select
                                        label="Area setting"
                                        options={this.state.areaSettings}
                                        onChange={(e) => { this.areaSettingSelected(e) }}
                                        isDisabled={this.state.adHocCbSelected}
                                    />
                                    {settingError && <span className="ca-error-text">Area setting is required.</span>}
                                </div>
                            </div>
                            <Checkbox style={{ marginLeft: "12px", marginBottom: "16px", textAlign: "left" }} checked={this.state.notifyOwnerOnDownload} onClick={(s) => { this.setState({ notifyOwnerOnDownload: s }) }}>
                                I want to be notified when users download files from this area.
                            </Checkbox>
                        </div>
                        <div style={{ display: "flex", justifyContent: "left", float: "left" }}>
                            <Button type="hover-bottom-left" onClick={this.cancel}>Cancel</Button>
                        </div>
                        <div style={{ display: "flex", justifyContent: "right", float: "right" }}>
                            <Button type="hover-bottom-left" onClick={this.createArea}>Create</Button>
                        </div>
                        <Tooltip id="adhoc-tooltip" />
                    </div>
                }
            </div>
        );
    }
}
export default withRouter(CreateArea);